import React from "react";

import TestMatchTabs from "./TestMatchTabs";

const InningsTabsAndTable = ({
  children,
  active,
  homeTeamLineup2,
  awayTeamLineup2,
  subActive,
  setSubActive,
}) => {
  const shouldShowTabs =
    (active === "home" && homeTeamLineup2) ||
    (active === "away" && awayTeamLineup2);

  return (
    <tbody>
      {shouldShowTabs && (
        <tr>
          <th colSpan={6}>
            <TestMatchTabs
              items={[
                { value: "1st innings", label: "1st innings" },
                { value: "2nd innings", label: "2nd innings" },
              ]}
              activeItem={subActive}
              onClick={setSubActive}
            />
          </th>
        </tr>
      )}
      {children}
    </tbody>
  );
};

export default InningsTabsAndTable;
